<script setup>
import logo from '@/core/assets/images/TeamUpLogoLight.svg'

const { t } = useI18n()
const { features: { customer_v2_hide_footer } } = useFeatures()

const currentYear = new Date().getFullYear()
</script>

<template>
  <div
    v-if="!customer_v2_hide_footer"
    class="app-footer min-h-402px flex flex-grow bg-secondary p-12"
  >
    <MainContainer class="flex flex-grow">
      <div class="box-border flex flex-grow flex-row lt-sm:(mx-auto max-w-292px) sm:mx-6">
        <div class="flex-grow text-text-300">
          <div
            class="md:(flex flex-row flex-wrap justify-between) xs:(flex flex-col flex-gap-8)"
          >
            <div class="footer__section w-102px">
              <a href="https://goteamup.com/"><img
                :src="logo"
                alt="TeamUp logo"
              ></a>
            </div>
            <div class="footer__section flex flex-col flex-gap-6">
              <div>
                <a
                  href="https://goteamup.com/company/terms/"
                  class="link footer-link hover:text-text-100"
                >{{
                  t('Terms of Service')
                }}</a>
              </div>
              <div>
                <a
                  href="https://goteamup.com/company/privacy/"
                  class="link footer-link hover:text-text-100"
                >{{
                  t('Privacy Policy')
                }}</a>
              </div>
              <div>
                <a
                  href="https://support.goteamup.com/en/collections/9210326-for-members-athletes-and-customers"
                  class="link footer-link hover:text-text-100"
                >{{
                  t('Support Guides')
                }}</a>
              </div>
              <div>
                <a
                  href="https://goteamup.com/"
                  class="link footer-link hover:text-text-100"
                >{{
                  t('Powered by TeamUp')
                }}</a>
              </div>
            </div>
            <div class="footer__section">
              <AppLocaleSwitcher />
            </div>
          </div>
          <div class="border-color-100 b-0.5 sm:(mt-25)" />
          <div class="mt-8 text-sm text-text-100">
            &copy; {{ currentYear }} {{ t('TeamUp. All rights reserved.') }}
          </div>
        </div>
      </div>
    </MainContainer>
  </div>
</template>

<i18n>
{
  "en-us": {
    "Terms of Service": "Terms of Service",
    "Privacy Policy": "Privacy Policy",
    "Support Guides": "Support Guides",
    "Powered by TeamUp": "Powered by TeamUp",
    "TeamUp. All rights reserved.": "TeamUp. All rights reserved.",
    "2023 TeamUp. All rights reserved.": "2023 TeamUp. All rights reserved."
  }
}
</i18n>

<i18n locale="de" lang="json">
{
  "Terms of Service": "Nutzungsbedingungen",
  "Privacy Policy": "Datenschutzerklärung",
  "Support Guides": "Support-Leitfäden",
  "Powered by TeamUp": "Präsentiert von TeamUp",
  "2023 TeamUp. All rights reserved.": "2023 TeamUp. Alle Rechte vorbehalten.",
  "TeamUp. All rights reserved.": "TeamUp. Alle Rechte vorbehalten."
}
</i18n>

<i18n locale="fr" lang="json">
{
  "Terms of Service": "Conditions d'utilisation",
  "Privacy Policy": "Politique de confidentialité",
  "Support Guides": "Guides d'assistance",
  "Powered by TeamUp": "Propulsé par TeamUp",
  "2023 TeamUp. All rights reserved.": "2023 TeamUp. All rights reserved.",
  "TeamUp. All rights reserved.": "TeamUp. Tous droits réservés."
}
</i18n>

<i18n locale="es" lang="json">
{
  "Terms of Service": "Términos del servicio",
  "Privacy Policy": "Política de privacidad",
  "Support Guides": "Guías de asistencia",
  "Powered by TeamUp": "Desarrollado por TeamUp",
  "2023 TeamUp. All rights reserved.": "2023 TeamUp. Todos los derechos reservados.",
  "TeamUp. All rights reserved.": "TeamUp. Todos los derechos reservados."
}
</i18n>
